import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';
import UserUtils from 'utils/User';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Switch+Country+API

function switchCountry(switchToCountry, languageCode) {
    let url = '/api/users/profile/switchCountry';
    const isUserAnonymous = UserUtils.isAnonymous();
    const isRCPSProfileBiGroupAPIEnabled = cookieUtils.isRCPSProfileBiGroupAPIEnabled();
    const { enableProfileBIGroup = false } = Sephora.configurationSettings;

    if (enableProfileBIGroup && isRCPSProfileBiGroupAPIEnabled && !isUserAnonymous) {
        url = '/gway/v2/users/profile/switchCountry';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify({
                switchToCountry,
                languageCode
            })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default switchCountry;
